import { render, staticRenderFns } from "./Appointments.vue?vue&type=template&id=06f43e58"
import script from "./Appointments.vue?vue&type=script&lang=ts"
export * from "./Appointments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports